<template>
  <!---->
  <div class="warp">
    <img src="http://yunlei-rabbit-hn2.oss-cn-heyuan.aliyuncs.com/2025/4/8/1909585488888004610.png" />
    <form action="/">
      <div class="box" style="margin-top: -30px">
        <!-- <div class="box"> -->
        <van-cell-group inset style="height: 42px" class="container">
          <van-field v-model="value" label="姓名" placeholder="请输入您的真实姓名" />
        </van-cell-group>
        <van-cell-group inset style="height: 42px" class="container">
          <van-field v-model="value1" label="手机" placeholder="请输入您的联系方式" type="digit" />
        </van-cell-group>
        <van-cell-group inset style="height: 65px" class="container">
          <van-field v-model="value2" label="学校/公司名称" placeholder="请输入您的学校/公司名称 " />
        </van-cell-group>
      </div>
      <div class="button" @click="join">
        <van-button type="primary" color="white" block round>
          <text style="color: skyblue; font-weight: bold; font-size: 20px">提交申请</text>
        </van-button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { Toast, Dialog } from "vant";
import { req } from "@/axios/http";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const value = ref("");
    const value1 = ref("");
    const value2 = ref("");
    return {
      value,
      value1,
      value2,
    };
  },
  methods: {
    join() {
      var num = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;

      if (this.value == "") Toast("输入的真实姓名不能为空!!");
      else if (this.value1 == "") Toast("输入的联系方式不能为空!!");
      else if (this.value1.length != 11) Toast("输入正确的电话号码!!");
      else if (!num.test(this.value1)) Toast("输入正确的电话号码!!");
      else if (this.value2 == "") Toast("输入的学校/公司名称不能为空!!");
      else
        req
          .post({
            url: "/app/rabbit/common/applycooperation/add",
            data: {
              name: this.value,
              phone: this.value1,
              companyName: this.value2,
            },
          })
          .then((res) => {
            console.log(res);
            Dialog.alert({
              title: "申请成功",
              message: "24小时内会有客服和您联系，请保持通讯通畅",
              theme: "round-button",
              confirmButtonColor: "#00c4ff",
            }).then(() => {
              this.value = "";
              this.value1 = "";
              this.value2 = "";
            });
          });
    },
  },
  created() {
    document.title = "合作";
  },
};
</script>

<style scoped>
#app {
  height: 100%;
  background-color: #fca028;
}

img {
  width: 100%;
  height: 700px;
}

.container {
  margin: 25px 15px;
  font-size: 20px;
}

label {
  font-weight: bold;
  color: black;
  font-size: 35px;
}

.button {
  width: 80%;
  margin: 40px auto;
}

.van-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.warp {
  height: 100vh;
}
</style>
